import React, { useEffect, useState } from 'react';
import Innerfolder from './Innerfolder';
import { ButtonC } from 'Common/Buttons';
import { Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';
import InputC from 'Common/Inputs/index.tsx';
import Axios from 'functions/Axios';
import close from '../../../assets/V2-images/close.svg';
import deleteicon from '../../../assets/V2-images/deleteicon.png';
import renameicon from '../../../assets/V2-images/renameicon.png';
import download from '../../../assets/V2-images/download.png';
import {
  Addfolder,
  DELETE_ASSETS_FOR_EVER,
  DELETE_MULTIPLE_ASSET,
  Editfolder,
  UPDATE_FOLDER_COLOR,
} from '../DAM_API/urls';
import SpinnerLoader from './../../SpinnerLoader';
import { toast } from 'react-toastify';
import { Deletemodel } from 'Common/Deletemodel';
import shareicon from '../../../assets/V2-images/shareicon.png';
import { useDispatch } from 'react-redux';
import {
  setInsideFolderData,
  setInsideFolderId,
  setOpenPopup,
  SetSelctedFoldersData,
  SelectedAssetData,
  SetInnerPrevSelected,
} from 'actions/damActions';
import Pagination from 'components/Pagination';
import { useLocation, useNavigate } from 'react-router-dom';
import { DAM_SVG } from '../DamAssets';
import CommonSidePortal from 'Common/SidePortal/SidePortal';
import WordWrapEllipse from '../WordWrapEllipse';
import { useSelector } from 'react-redux';
import ShareAssetSection from '../Components/Featured/ShareAsset';
import CommonThreeDotSvg from '../Components/CommonThreeDotSvg';
import FolderGridSecondVersion from '../Components/FolderGridSecondVersion';
import { selectRangeByUUID } from '../Assets/assitdata';
import MoveToAssetDesign from '../Components/Featured/MoveToAssetDesign';
import { useDownloadAssets } from 'context/DownloadAssetsContext';
import { MODULE_IDS, useHasAccess, USER_RIGHTS } from 'actions/userActions';
import { selectionColors } from '../Types';
import { DAM_API_URL } from 'Constant';
import PropertiesPopup from '../Components/PropertiesPopup';

export const GridFolderData = ({
  isPoppedUp,
  HandleSave,
  isUpload = true,
  data,
  setdata,
  innerfolderValue = true,
  HandleDelete,
  showPagination = true,
  fromBrandAssets,
  setfolderId,
  selectedfolderid,
  trash,
}) => {
  const { startDownload } = useDownloadAssets();
  const [showInnerFolder, setShowInnerFolder] = useState(innerfolderValue);
  // const [data, setdata] = useState([]);
  const [selectedDamFieldId, setSelectedDamFieldId] = useState(null);
  const [AddToCollectionModal, setAddToCollectionModal] = useState(false);
  const [textvalue, settextvalue] = useState();
  const [showbar, setshowbar] = useState(false);
  const [modal, setModal] = useState(false);
  const [responsedLink, setResponsedLink] = useState();
  const [assetInfo, setAssetInfo] = useState({});
  const [isExpiration, setIsExpiration] = useState(false);
  const [error, setError] = useState({});
  const [prevIndexSelected, setPrevIndexSelected] = useState();
  const [colorSelect, setColorSelect] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const toggle = () => setModal(true);
  const [isLoading, setIsLoading] = useState(false);
  const [deletemodal, setdeletemodal] = useState(false);
  const [movetoModal, setMovetoModal] = useState(false);
  const [sharelink, setsharelink] = useState(false);
  const [expiredate, setexpiredate] = useState();
  const [expitetime, setexpitetime] = useState();
  const [indexdata, setindexdata] = useState();
  const [Authenticated, setAuthenticated] = useState(false);
  const [emails, setEmails] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [passname, setpassname] = useState('');
  const [activeId, setActiveId] = useState();
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [openRightSection, setOpenRightSection] = useState(false);
  const dispatch = useDispatch();
  const hasDAMAccess = useHasAccess();
  const hasDAm = hasDAMAccess(MODULE_IDS.DAM);
  const hasFullAccess = hasDAMAccess(MODULE_IDS.DAM, [USER_RIGHTS.FullAccess]);
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const { selectedAssets, selectedFolders, indexSelected } = useSelector((state) => state.dam);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500); // Adjust the delay time as needed

    // Cleanup function to clear the timeout if the user keeps typing
    return () => {
      clearTimeout(handler);
    };
  }, [search]);

  const closeBtn = (
    <img
      src={close}
      alt="close"
      className="close"
      onClick={() => setModal(false)}
      style={{ cursor: 'pointer' }}
    />
  );

  const closeBtn1 = (
    <img
      src={close}
      alt="close"
      className="close"
      onClick={() => setAddToCollectionModal(false)}
      style={{ cursor: 'pointer' }}
    />
  );

  const fetchfolder = async () => {};

  useEffect(() => {
    const delaysearcfun = setTimeout(async () => {
      // fetchfolder(debouncedSearch);
    }, 500);
    return () => clearTimeout(delaysearcfun);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearch, currentPage]);

  const handleClick = (id) => {
    if (!fromBrandAssets) {
      navigate(`${id}`);
      dispatch(setInsideFolderData(true));
      dispatch(setInsideFolderId(id));
      setShowInnerFolder(false);
      setSelectedDamFieldId(id);
    } else {
      setfolderId((pre) => [...pre, id]);
    }
  };

  const resethandleClick = () => {
    // console.log('inside resethanlder function');
    navigate('/dam/v2/assets');
    dispatch(setInsideFolderData(true));
    dispatch(setInsideFolderId(null));
    setShowInnerFolder(true);
    // dispatch(setInsideFolderData(true));
    setSelectedDamFieldId(null);
  };

  const toggleAddToCollection = () => {
    setAddToCollectionModal(!AddToCollectionModal);
  };

  const handleChange = (evt) => {
    const { value } = evt.target;
    settextvalue(value);
  };

  const handleshow = (id) => {
    setshowbar(id === showbar ? null : id);
    setSelectedDamFieldId(id);
  };

  const folderaddded = async () => {
    if (!textvalue == '') {
      try {
        const formData = new FormData();
        formData.append('folderName', textvalue);
        const response = await Axios.post(Addfolder, formData);
        if (response.data.success) {
          // Folder created successfully, fetch updated folder data
          toast.success(response?.data?.message ?? 'Folder created successfully'); // Moved toast.success here

          fetchfolder();
          setModal(false);
        } else {
          // Handle error case
        }
      } catch (error) {
        toast.error(error.response.data.message);
      }
    } else {
      toast.error('Please enter a valid folder name');
    }
    // Close the modal
  };

  const folderedit = async () => {
    try {
      const formData = new FormData();
      formData.append('folderId', selectedDamFieldId);
      formData.append('newFolderName', textvalue);
      const response = await Axios.post(Editfolder, formData);
      if (response.data.success) {
        HandleDelete();
        setAddToCollectionModal(false);
        toast.success(response?.data?.message ?? 'Folder Renamed Successfully');
      } else {
        // Handle error case
        setAddToCollectionModal(false);
        toast.error('Folder Rename Failed');
      }
    } catch (error) {
      // Handle error
    }
    setAddToCollectionModal(false);
    setshowbar(false);
  };

  const handledelette = async () => {
    try {
      setDeleteLoading(true);
      setTimeout(() => {
        setdeletemodal(false);
      }, 4000);
      const result = await Axios.post(trash ? DELETE_ASSETS_FOR_EVER : DELETE_MULTIPLE_ASSET, {
        fileId: [],
        folderId: [selectedDamFieldId],
      });
      fetchfolder();
      setDeleteLoading(false);
      setdeletemodal(false);
      HandleDelete && HandleDelete();
    } catch (err) {
      setDeleteLoading(false);
      console.error(err);
    }
  };

  async function handleRestoreAsset(id) {
    await Axios.post(`${DAM_API_URL}/apidam/restore-delete-asset`, {
      folderId: [id],
    });
    fetchfolder();
    HandleDelete && HandleDelete();
    setActiveId(null);
  }

  const handleshowdata = async (damFileId, index) => {
    setResponsedLink();
    setError({});
    setexpiredate();
    setexpitetime();
    setAssetInfo({});
    setEmails([]);
    setAuthenticated(true);
    setIsExpiration(false);
    setindexdata(index);
    setsharelink(!sharelink);
    setshowbar(false);
    setActiveId();
  };

  const deletmodal = (folderName) => {
    setdeletemodal(true);
    setpassname(folderName);
  };

  const handlePageChange = async (data) => {
    setCurrentPage(data?.currentPage ?? 1);
  };

  const handledownload = async (data) => {
    try {
      var _data = {
        fileId: [],
        folderId: [data?.id],
      };
      await startDownload(_data);
      setActiveId();
    } catch (err) {
      console.error(err);
    }
  };
  const title = passname;
  const toggledelete = () => setdeletemodal(!deletemodal);
  const handleSaveColor = async (Data, selectedColor) => {
    try {
      const result = await Axios.put(UPDATE_FOLDER_COLOR, {
        color: selectedColor?.hex,
        folderId: Data?.id,
      });
      toast.success(result?.data?.message);
      setActiveId(null);
      HandleDelete();
      setOpenRightSection(false);
      // setSelectedColor();
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      setShowInnerFolder(false);
      dispatch(setInsideFolderData(false));
      setSelectedDamFieldId(location?.state?.data?.id);
    }
  }, [location]);

  return (
    <>
      {deletemodal && (
        <Deletemodel
          deletemodal={deletemodal}
          toggledelete={toggledelete}
          handleDelete={handledelette}
          loading={deleteLoading}
          Header={title}
        />
      )}
      {movetoModal && (
        <MoveToAssetDesign
          OpenModal={movetoModal}
          ToggleModal={() => {
            setMovetoModal(!movetoModal);
          }}
          HandleAssetMove={() => {
            HandleDelete();
          }}
          Data={selectedDamFieldId}
        />
      )}
      <Modal isOpen={modal} toggle={toggle} style={{ width: '50%' }}>
        <ModalHeader toggle={toggle} close={closeBtn}>
          Add Folder
        </ModalHeader>
        <ModalBody>
          <InputC
            type="text"
            label="Folder Name"
            name="textvalue"
            placeholder="Enter name of folder"
            change={(e) => handleChange(e)}
          />
        </ModalBody>
        <ModalFooter style={{ borderTop: 'none' }}>
          <ButtonC text="Close" click={() => setModal(false)} size="lg" color="Secondary" />
          <ButtonC text="Save" click={folderaddded} size="lg" />
        </ModalFooter>
      </Modal>

      <Modal isOpen={AddToCollectionModal} toggle={toggleAddToCollection} style={{ width: '50%' }}>
        <ModalHeader toggle={toggleAddToCollection} close={closeBtn1}>
          Rename Folder
        </ModalHeader>
        <ModalBody>
          <InputC
            type="text"
            label=""
            name="textvalue"
            placeholder="Enter name of folder"
            inputvalue={textvalue}
            change={(e) => handleChange(e)}
          />
        </ModalBody>
        <ModalFooter style={{ borderTop: 'none' }}>
          <ButtonC
            text="Close"
            color="Secondary"
            size="lg"
            click={() => setAddToCollectionModal(false)}
          />
          <ButtonC text="Save" size="lg" click={folderedit} />
        </ModalFooter>
      </Modal>
      {sharelink && (
        <ShareAssetSection
          openModal={sharelink}
          ParentId={[selectedDamFieldId]}
          toggleOpenModal={() => {
            setsharelink(!sharelink);
          }}
          shareType={0}
        />
      )}

      {/* <div className="dis_grid grid_cols_5">
        {' '}
        <ImageGridSecondVersion />
      </div> */}

      {/* <ShareAssetSection /> */}

      {showInnerFolder ? (
        <div className="">
          <div className={`d-flex justify-content-${!isPoppedUp ? 'between' : 'end'}`}>
            {!isPoppedUp && (
              <InputC
                type="Searchbar"
                placeholder="Search Folder Name"
                size="lg"
                name=""
                change={(e) => {
                  setSearch(e.target.value);
                }}
                inputvalue={search}
              />
            )}
            {!isPoppedUp && <ButtonC size="lg" text="New Folder" click={toggle} />}
          </div>

          {isLoading ? (
            <SpinnerLoader />
          ) : (
            <div
              style={{
                marginBottom: '1rem',
              }}
            >
              {selectedFolders?.length !== 0 ? (
                <div
                  className="dis_grid asset_section_resposive_grid_5 "
                  style={{
                    gap: '1rem',
                  }}
                >
                  {selectedFolders?.map((value, index) => {
                    return (
                      <div className="" key={index}>
                        <FolderGridSecondVersion
                          trash={trash}
                          Data={value}
                          Index={index}
                          Title={<WordWrapEllipse Text={value?.folderName} MaxWidth={'12ch'} />}
                          selectedfolderid={selectedfolderid}
                          HandleSelect={(data) => {
                            if (data?.Key === 4) {
                              handleClick(value?.id);
                              return;
                            }

                            if (data?.Key === 1) {
                              setPrevIndexSelected(value?.id);
                              dispatch(SetInnerPrevSelected(value?.id));

                              const updatedValue = selectedFolders?.map((item) =>
                                item?.id === value?.id
                                  ? { ...item, isSelected: !item?.isSelected }
                                  : { ...item, isSelected: false },
                              );
                              dispatch(
                                SelectedAssetData(
                                  selectedAssets?.map((item) => ({
                                    ...item,
                                    isSelected: false,
                                  })),
                                ),
                              );
                              dispatch(SetSelctedFoldersData(updatedValue));
                            } else if (data?.Key === 2) {
                              setPrevIndexSelected(value?.id);
                              dispatch(SetInnerPrevSelected(value?.id));
                              const updatedValue = selectedFolders?.map((item) =>
                                item?.id === value?.id
                                  ? { ...item, isSelected: !item?.isSelected }
                                  : { ...item },
                              );

                              dispatch(SetSelctedFoldersData(updatedValue));
                            } else if (data?.Key === 3) {
                              const _alldata = [
                                ...(selectedFolders ?? [])?.map((item) => ({
                                  ...item,
                                  identifactor: 1,
                                  idx: item?.id,
                                })),
                                ...(selectedAssets ?? [])?.map((item) => ({
                                  ...item,
                                  identifactor: 2,
                                  idx: item?.assetId,
                                })),
                              ];

                              const returnedValueData2 = selectRangeByUUID(
                                _alldata,
                                indexSelected,
                                value?.id,
                                'idx',
                              );

                              const filteredFolder = returnedValueData2?.filter(
                                (item) => item?.identifactor === 1,
                              );
                              const filteredAsset = returnedValueData2?.filter(
                                (item) => item?.identifactor === 2,
                              );

                              dispatch(SelectedAssetData(filteredAsset));
                              dispatch(SetSelctedFoldersData(filteredFolder));
                            }
                          }}
                          isFolder={true}
                          isSelected={value?.isSelected}
                          isEllipse={hasDAMAccess(MODULE_IDS.DAM)}
                          EllipseActions={(data) => {
                            // const isSelf = hasDAMAccess(MODULE_IDS.DAM, [USER_RIGHTS.FullAccess])
                            //   ? true
                            //   : data.isSelf;
                            const isSelf = data.isSelf;
                            return (
                              <CommonSidePortal
                                activeId={activeId}
                                setActiveId={setActiveId}
                                portalId={index}
                                ViewSection={<CommonThreeDotSvg />}
                                OpenSection={
                                  trash ? (
                                    <>
                                      {' '}
                                      {(isSelf ||
                                        hasDAMAccess(MODULE_IDS.DAM, [USER_RIGHTS.FullAccess])) && (
                                        <div
                                          className="d-flex align-items-center gap-2 pointer"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setActiveId();

                                            setSelectedDamFieldId(value?.id);

                                            deletmodal(value?.folderName);
                                          }}
                                        >
                                          {' '}
                                          <img src={deleteicon} alt="deleteicon" />{' '}
                                          <p className="list_cart">
                                            {trash ? 'Delete' : 'Move to trash'}
                                          </p>
                                        </div>
                                      )}
                                      {(isSelf ||
                                        hasDAMAccess(MODULE_IDS.DAM, [USER_RIGHTS.FullAccess])) && (
                                        <div
                                          className="d-flex align-items-center gap-2 pointer"
                                          onClick={() => {
                                            // setSelectedDamFieldId(image.damFileId);
                                            handleRestoreAsset(value.id);
                                          }}
                                        >
                                          {/* <img src={deleteicon} alt="deleteicon" /> */}

                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="lucide lucide-archive-restore-icon lucide-archive-restore"
                                          >
                                            <rect width="20" height="5" x="2" y="3" rx="1" />
                                            <path d="M4 8v11a2 2 0 0 0 2 2h2" />
                                            <path d="M20 8v11a2 2 0 0 1-2 2h-2" />
                                            <path d="m9 15 3-3 3 3" />
                                            <path d="M12 12v9" />
                                          </svg>
                                          <p className="list_cart">Restore</p>
                                        </div>
                                      )}
                                      <PropertiesPopup
                                        folderId={value?.id}
                                        baseUrl={DAM_API_URL}
                                        label="Properties"
                                      />
                                    </>
                                  ) : (
                                    <div className="">
                                      {(isSelf ||
                                        hasDAMAccess(MODULE_IDS.DAM, [USER_RIGHTS.FullAccess])) && (
                                        <div
                                          className="d-flex align-items-center gap-2 pointer"
                                          onClick={() => {
                                            setMovetoModal(true);
                                            setSelectedDamFieldId(value.id);
                                            setActiveId();
                                          }}
                                        >
                                          {DAM_SVG.moveAssetSvgIcon}
                                          <p className="list_cart">Move Folder</p>
                                        </div>
                                      )}
                                      {(isSelf ||
                                        hasDAMAccess(MODULE_IDS.DAM, [USER_RIGHTS.FullAccess])) && (
                                        <div
                                          className="d-flex align-items-center gap-2 pointer"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setActiveId();

                                            setSelectedDamFieldId(value?.id);

                                            deletmodal(value?.folderName);
                                          }}
                                        >
                                          {' '}
                                          <img src={deleteicon} alt="deleteicon" />{' '}
                                          <p className="list_cart">
                                            {trash ? 'Delete' : 'Move to trash'}
                                          </p>
                                        </div>
                                      )}
                                      {(isSelf || hasDAMAccess(MODULE_IDS.DAM)) && (
                                        <div
                                          className="d-flex align-items-center gap-2 pointer"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setActiveId();

                                            handledownload(value);
                                          }}
                                        >
                                          {' '}
                                          <img src={download} alt="downloadicon" />{' '}
                                          <p className="list_cart">Download</p>
                                        </div>
                                      )}
                                      {(isSelf ||
                                        hasDAMAccess(MODULE_IDS.DAM, [USER_RIGHTS.FullAccess])) && (
                                        <div
                                          className="d-flex align-items-center gap-2 pointer"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setActiveId();
                                            setSelectedDamFieldId(value?.id);

                                            settextvalue(value?.folderName);
                                            setAddToCollectionModal(!AddToCollectionModal);
                                          }}
                                        >
                                          <img src={renameicon} alt="renameicon" />
                                          <p className="list_cart">Rename</p>
                                        </div>
                                      )}
                                      {(isSelf ||
                                        hasDAMAccess(MODULE_IDS.DAM, [USER_RIGHTS.FullAccess])) && (
                                        <div
                                          className="p-relative"
                                          style={{
                                            position: 'relative',
                                          }}
                                        >
                                          <div
                                            className="d-flex justify-content-between align-items-center gap-2 pointer"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setOpenRightSection(!openRightSection);
                                            }}
                                          >
                                            <div className="d-flex gap-2 align-items-center">
                                              {DAM_SVG.labelByColorSvgIcon}
                                              <p className="list_cart">Label By Color</p>
                                            </div>
                                            <div
                                              style={{
                                                paddingRight: '16px',
                                              }}
                                              onClick={(e) => {
                                                // e.stopPropagation();
                                                // setOpenRightSection(!openRightSection);
                                              }}
                                            >
                                              {DAM_SVG.rightSideSvgIcon}
                                            </div>
                                            {/* <img src={renameicon} alt="renameicon" /> */}
                                          </div>
                                          {openRightSection && (
                                            <div
                                              className="p-absolute cart_list"
                                              style={{
                                                position: 'absolute',
                                                left: '100%',
                                                padding: '16px',
                                              }}
                                            >
                                              <div className="color_heading">Folder Color</div>

                                              <div className="dis_grid grid_cols_5 gap-2">
                                                {selectionColors?.map((item) => (
                                                  <div
                                                    style={{
                                                      backgroundColor: item?.hex,
                                                      width: '32px',
                                                      height: '32px',
                                                      borderRadius: '50%',
                                                      display: 'flex',
                                                      justifyContent: 'center',
                                                      alignItems: 'center',
                                                    }}
                                                    onClick={() => {
                                                      handleSaveColor(value, item);
                                                    }}
                                                  >
                                                    {' '}
                                                    {value?.color === item?.hex &&
                                                      DAM_SVG.folderSelectTickIcon}
                                                  </div>
                                                ))}
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      )}
                                      {(isSelf ||
                                        hasDAMAccess(MODULE_IDS.DAM, [USER_RIGHTS.FullAccess])) && (
                                        <div
                                          className="d-flex align-items-center gap-2 pointer"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            dispatch(setOpenPopup(value));
                                            setActiveId();
                                          }}
                                        >
                                          {' '}
                                          <img src={shareicon} alt="componenticon" />{' '}
                                          <p className="list_cart">Share</p>
                                        </div>
                                      )}
                                      {(isSelf || hasDAMAccess(MODULE_IDS.DAM)) && (
                                        <div
                                          className="d-flex align-items-center gap-2 pointer"
                                          onClick={(e) => {
                                            e.stopPropagation();

                                            setActiveId();
                                            setSelectedDamFieldId(value?.id);
                                            handleshowdata(value?.id, 0);
                                          }}
                                        >
                                          {' '}
                                          {DAM_SVG.permissionSvg}
                                          <p className="list_cart">Invite</p>
                                        </div>
                                      )}
                                      <PropertiesPopup
                                        folderId={value?.id}
                                        align="right"
                                        baseUrl={DAM_API_URL}
                                        label="Properties"
                                      ></PropertiesPopup>
                                    </div>
                                  )
                                }
                                HandleEllipseClick={() => {
                                  const updatedValue = selectedFolders?.map((item) =>
                                    item?.id === value?.id
                                      ? { ...item, isSelected: !item?.isSelected }
                                      : { ...item, isSelected: false },
                                  );

                                  dispatch(SetSelctedFoldersData(updatedValue));
                                }}
                                Top={'15px'}
                                Right={'170px'}
                              />
                            );
                          }}
                        />
                      </div>
                    );
                  })}
                  {showPagination && (
                    <Pagination
                      type="Sticky"
                      totalPages={data?.metadata?.totalAmountOfPages}
                      currentPage={data?.metadata?.currentPage}
                      onPageChanged={handlePageChange}
                    />
                  )}
                </div>
              ) : (
                <div className=" d-flex align-item-center justify-content-center">
                  {/* <div className="w-50">
                    <Nodatacomponent text={'No folder found'} />
                  </div> */}
                </div>
              )}
            </div>
          )}
        </div>
      ) : (
        <div>
          <Innerfolder
            damfieldid={selectedDamFieldId}
            data={data}
            resethandleClick={resethandleClick}
            isPoppedUp={isPoppedUp}
            HandleSave={HandleSave}
            isUpload={isUpload}
            selectedfolderid={selectedfolderid}
            // assetsData={{
            //   folders: insideFolderFolderData?.folders?.[0]?.folders ?? [],
            //   images: insideFolderFolderData?.files ?? [],
            // }}
            // stateData={insideFolderFolderData?.folders  ? insideFolderFolderData : []}
          />
        </div>
      )}
    </>
  );
};
